import { OutlinedInput, SxProps, Tooltip } from '@mui/material'
import { FormFieldInputProps } from '../_props'
import { DEFAULT_NO_VALUE } from '../../_utils/utils'
import { defaultPalette } from '../../../../../theme/idsTheme'
import { msxs } from '../../../../../theme/_utils'

const withValueSx: SxProps = {
    width: '100%',
    '> input': {
        color: `${defaultPalette.typography.main} !important`,
        WebkitTextFillColor: `${defaultPalette.typography.main} !important`,
    },
}

const withDefaultPlaceholderSx: SxProps = {
    width: '100%',
    '> input': {
        color: `${defaultPalette.lightGrey.darker} !important`,
        WebkitTextFillColor: `${defaultPalette.lightGrey.darker} !important`,
    },
}

const FormFieldInput = <T extends object>({
    placeholder,
    name,
    value,
    onChange,
    locked,
    disabled,
    startAdornment,
    endAdornment,
    dataCy,
    dataCyScope,
    inputProps,
    renderLabel,
    tooltipTitle,
    tooltipPosition,
}: FormFieldInputProps<T>) => {
    const isDisabled = locked || disabled
    return (
        <Tooltip title={tooltipTitle} hidden={tooltipPosition === 'label'} placement="top" arrow>
            <OutlinedInput
                placeholder={placeholder}
                inputProps={inputProps}
                required
                autoComplete="none"
                id={name.toString()}
                name={name.toString()}
                data-cy={dataCy ?? `dataCy_${dataCyScope ?? 'FormFieldInput'}-${name.toString()}`}
                onChange={onChange}
                value={renderLabel && value ? renderLabel() : value ?? ''}
                disabled={isDisabled}
                endAdornment={endAdornment}
                startAdornment={startAdornment}
                sx={msxs(
                    value || (!value && placeholder !== DEFAULT_NO_VALUE) ? withValueSx : undefined,
                    !value && (!isDisabled || placeholder === DEFAULT_NO_VALUE) ? withDefaultPlaceholderSx : undefined,
                )}
            />
        </Tooltip>
    )
}

export default FormFieldInput
